import React, { Component } from 'react';
import PropTypes from 'prop-types';

class AccordianItem extends Component {
  constructor (props) {
    super(props);
    this.itemClickHandler = this.itemClickHandler.bind(this);
  }
  itemClickHandler () {
    this.props.handleItemClick(this.props.item.id);
  }
  render () {
    return (
      <li className={'screenshot-explainer__item' + (this.props.selectedId === this.props.item.id ? ' is-selected' : '')}>
        <a onClick={this.itemClickHandler} className='screenshot-explainer__title'><h2>{this.props.item.title}</h2></a>
        <div className='screenshot-explainer__content'>
          <p>{this.props.item.description}</p>
          <img className='screenshot-explainer__image' src={this.props.item.image} alt='Screenshot' />
        </div>
      </li>
    );
  }
}

AccordianItem.propTypes = {
  selectedId: PropTypes.number,
  item: PropTypes.object,
  handleItemClick: PropTypes.func
};

export default AccordianItem;



// WEBPACK FOOTER //
// ./src/components/AccordianItem/index.js